import { Component } from 'react';
import PropTypes from 'prop-types';

import PlaceholderCard from './PlaceholderCard';
import Card from './Card';

import autoServiceApi from '../../../../utils/autoServiceApi';

export default class DirectSalesCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      directSales: [],
      isFetching: true,
    };

    this.carousel = null;

    this.initCarousel = this.initCarousel.bind(this);
    this.fetchDirectSales = this.fetchDirectSales.bind(this);
    this.filteredDirectSalesList = this.filteredDirectSalesList.bind(this);
  }

  componentDidMount() {
    this.initCarousel();
    this.fetchDirectSales();
  }

  componentDidUpdate() {
    this.initCarousel();
  }

  filteredDirectSalesList(directSalesList) {
    const { currentDirectSaleSlug } = this.props;
    const limitDirectSalesList = directSalesList.slice(0, 8);

    if (!currentDirectSaleSlug) return limitDirectSalesList;

    const currentDirectSaleIsPresent = directSalesList.find(
      directSales => directSales.slug === currentDirectSaleSlug,
    );

    if (currentDirectSaleIsPresent) {
      const filteredDirectSalesList = directSalesList.filter(
        directSales => directSales.slug !== currentDirectSaleSlug,
      );

      return filteredDirectSalesList;
    }

    return limitDirectSalesList;
  }

  async fetchDirectSales() {
    const { currentCategoryId } = this.props;

    const requestParams = [
      { 'q[active_eq]': true },
      { 'q[category_direct_sale_id_eq]': currentCategoryId },
      { per_page: 9 },
      { page: 1 },
      { sort: 'ordination,id' },
    ];
    const result = await autoServiceApi.getDirectSales(requestParams);

    const directSalesList = result ? result.entries : this.state.directSales;
    const filteredDirectSalesList =
      this.filteredDirectSalesList(directSalesList);

    this.setState(() => ({
      directSales: filteredDirectSalesList,
      isFetching: false,
    }));
  }

  initCarousel() {
    if (this.carousel) this.carousel.destroy();

    const carousel = window.makeCarousel(this.carouselRef, {
      perPage: 4,
      perMove: 1,
      pagination: true,
      lazyLoad: 'nearby',
      preloadPages: 0,
      gap: 24,
      breakpoints: {
        768: {
          perPage: 1,
          perMove: 1,
          fixedWidth: 272,
        },
        990: {
          perPage: 2,
          perMove: 1,
          gap: 24,
          padding: 24,
          pagination: false,
          arrows: false,
          drag: true,
        },
        1200: {
          perPage: 4,
          perMove: 1,
        },
      },
    });

    this.carousel = carousel;

    return carousel;
  }

  render() {
    const { directSales, isFetching } = this.state;
    const { cardLink } = this.props;

    return (
      <div
        className="direct-sales__carousel splide"
        data-is-fetching={isFetching}
        ref={node => {
          this.carouselRef = node;
        }}
      >
        <div className="splide__track container">
          <div className="splide__list direct-sales__carousel-items-wrapper">
            {isFetching &&
              directSales.length === 0 &&
              [1, 2, 3, 4, 5, 6, 7, 8].map(item => (
                <div
                  className="direct-sales__carousel-placeholder__item carousel__item splide__slide"
                  key={item}
                >
                  <PlaceholderCard />
                </div>
              ))}
            {!isFetching &&
              directSales.length > 0 &&
              directSales.map(directSale => (
                <div
                  className="direct-sales__carousel-item splide__slide"
                  key={directSale.slug}
                >
                  <Card
                    slug={directSale.slug}
                    image={
                      directSale.item_image &&
                      directSale.item_image.middle_image
                    }
                    title={directSale.title}
                    subtitle={directSale.subtitle}
                    seal_list={directSale.seal_list}
                    secondary_call={
                      directSale.item_offer &&
                      directSale.item_offer.secondary_call
                    }
                    main_call={
                      directSale.item_offer && directSale.item_offer.main_call
                    }
                    featured={
                      directSale.item_offer && directSale.item_offer.featured
                    }
                    description={
                      directSale.item_offer && directSale.item_offer.description
                    }
                    extra={directSale.item_offer && directSale.item_offer.extra}
                    badge={directSale.badge}
                    part_link={cardLink}
                    brand={directSale.brand.name}
                    expiredAt={directSale.expired_at}
                    offerType={directSale.offer_type}
                    categorySlug={directSale.category_slug}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }
}

DirectSalesCarousel.defaultProps = {
  cardLink: '/vendas-diretas',
  currentDirectSaleSlug: '',
  currentCategoryId: '',
};

DirectSalesCarousel.propTypes = {
  cardLink: PropTypes.string,
  currentDirectSaleSlug: PropTypes.string,
  currentCategoryId: PropTypes.string,
};
